import {
  ODSDatePicker,
  type ODSDatePickerFormat,
  type ODSDatePickerLocale,
  type ODSDatePickerProps,
} from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';
import { useIntl } from 'react-intl';

interface DateFieldProps {
  id: string;
  name: string;
  format?: ODSDatePickerFormat;
  size?: 'small' | 'large';
  value?: string | Date;
  maxDate?: Date;
  minDate?: Date;
  onChange?: ODSDatePickerProps['onChange'];
  onBlur?: ODSDatePickerProps['onBlur'];
  label: string;
  disabled?: boolean;
  helperText?: string;
}

export const DateField: FC<DateFieldProps> = ({
  id,
  name,
  format = 'DD.MM.YYYY',
  size = 'small',
  value,
  maxDate,
  minDate,
  onChange,
  onBlur,
  label,
  disabled = false,
  helperText,
}) => {
  const intl = useIntl();
  const flyoutProps = {
    monthButtonProps: {
      'aria-label': intl.formatMessage({ id: 'switchToMonthView' }),
    },
    nextMonthButtonProps: {
      'aria-label': intl.formatMessage({ id: 'goToNextMonth' }),
    },
    previousMonthButtonProps: {
      'aria-label': intl.formatMessage({ id: 'goToPreviousMonth' }),
    },
    yearButtonProps: {
      'aria-label': intl.formatMessage({ id: 'switchToYearView' }),
    },
  };

  return (
    <ODSDatePicker
      id={id}
      aria-label={name}
      locale={intl.locale as ODSDatePickerLocale}
      flyoutProps={flyoutProps}
      format={format}
      inputProps={{
        disabled,
        label,
        placeholder: value as string,
        mode: helperText ? 'informative' : 'standard',
        ...(helperText && {
          supportMessageProps: {
            helperText,
            message: helperText,
          },
        }),
      }}
      {...(maxDate && { maxDate })}
      {...(minDate && { minDate })}
      {...(onChange && { onChange })}
      size={size}
      defaultDate={value as Date}
      onBlur={onBlur}
    />
  );
};
